var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      ref: "menu",
      staticClass: "date-time-picker-menu",
      attrs: {
        "close-on-content-click": false,
        "content-class": "date-time-picker-menu-content",
        "allow-overflow": "",
        "min-width": "290px",
        "offset-y": "",
        bottom: "",
        left: "",
        "nudge-right": _vm.$attrs["text-field-prepend-icon"] ? "31px" : "0",
        origin: "top right",
        disabled: _vm.disabled,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.displayValue,
                        tabindex: _vm.textFieldTabIndex,
                      },
                      on: {
                        change: _vm.onTextFieldChange,
                        "click:clear": _vm.onTextFieldClear,
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                          )
                            return null
                          return _vm.closeMenu.apply(null, arguments)
                        },
                      },
                    },
                    "v-text-field",
                    _vm.textFieldAttrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c("div", [
        _c(
          "div",
          {
            staticStyle: {
              "max-width": "290px",
              "max-height": "378px",
              overflow: "hidden",
            },
          },
          [
            _c(
              "transition",
              { attrs: { name: "slide" } },
              [
                _vm.isDatePickerVisible
                  ? _c(
                      "v-date-picker",
                      _vm._b(
                        {
                          ref: "datepicker",
                          class: ["date-time-picker-date-picker"],
                          attrs: {
                            locale: _vm.locale,
                            "active-picker": "activePicker",
                            "picker-date": _vm.pickerDate,
                            "first-day-of-week": "1",
                          },
                          on: {
                            "update:pickerDate": function ($event) {
                              _vm.pickerDate = $event
                            },
                            "update:picker-date": function ($event) {
                              _vm.pickerDate = $event
                            },
                            input: _vm.onDatePickerInput,
                          },
                          model: {
                            value: _vm.dateStr,
                            callback: function ($$v) {
                              _vm.dateStr = $$v
                            },
                            expression: "dateStr",
                          },
                        },
                        "v-date-picker",
                        _vm.datePickerAttrs,
                        false
                      )
                    )
                  : _c(
                      "v-time-picker",
                      _vm._b(
                        {
                          ref: "timepicker",
                          class: ["date-time-picker-time-picker"],
                          attrs: { format: "24hr" },
                          on: { change: _vm.onTimePickerChange },
                          model: {
                            value: _vm.timeStr,
                            callback: function ($$v) {
                              _vm.timeStr = $$v
                            },
                            expression: "timeStr",
                          },
                        },
                        "v-time-picker",
                        _vm.timePickerAttrs,
                        false
                      )
                    ),
              ],
              1
            ),
          ],
          1
        ),
        !_vm.isDateOnly && !_vm.isTimeOnly
          ? _c(
              "div",
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-0",
                    attrs: { block: "", depressed: "" },
                    on: { click: _vm.toggleMode },
                  },
                  [
                    _vm.isDatePickerVisible
                      ? _c(
                          "v-icon",
                          _vm._b({}, "v-icon", _vm.iconAttrs, false),
                          [_vm._v(" access_time ")]
                        )
                      : _c(
                          "v-icon",
                          _vm._b({}, "v-icon", _vm.iconAttrs, false),
                          [_vm._v(" event ")]
                        ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }